module.exports = __webpack_public_path__ + "img/check2-active.c548bc5a.svg";